import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

/**
 * GraphQL mutation for adding a new pricing metric
 */
const ADD_PRICING_METRIC_MUTATION = gql`
  mutation AddPricingMetric($input: PricingMetricInput!) {
    addPricingMetric(input: $input) {
      id
      display_name
      modality
      sample_values
    }
  }
`;

/**
 * Type for the add pricing metric input
 */
export interface AddPricingMetricInput {
  display_name: string;
  modality?: string;
  sample_values?: string[];
  page_id: string;
}

/**
 * Type for the add pricing metric response
 */
export interface AddPricingMetricResponse {
  addPricingMetric: {
    id: string;
    display_name: string;
    modality?: string | null;
    sample_values?: string[] | null;
  };
}

/**
 * GraphQL mutation to add a new pricing metric
 * 
 * @param input The pricing metric data to add
 * @returns Response containing the new pricing metric data
 */
export async function addPricingMetricMutation(
  input: AddPricingMetricInput
): Promise<AddPricingMetricResponse> {
  try {
    console.log(`🔄 [GraphQL] Adding new pricing metric: ${input.display_name}`, input);
    
    // Execute the GraphQL mutation
    const response = await graphqlClient.request<AddPricingMetricResponse>(
      ADD_PRICING_METRIC_MUTATION,
      { input }
    );
    
    console.log('✅ [GraphQL] Pricing metric creation response:', response);
    
    return response;
  } catch (error) {
    console.error('❌ [GraphQL] Error creating pricing metric:', error);
    throw error;
  }
}
